import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/actions/dataActions';



//charts
import { Line, defaults } from 'react-chartjs-2';


class Player extends Component {

    constructor(props) {
        super(props);
    }


    componentDidMount() {
        // This method is called when the component is first added to the document

    }

    componentDidUpdate() {

    }

    ensureDataFetched() {
        const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
        // this.props.requestWeatherForecasts(startDateIndex);
        this.props.getData();

    }

    

    render() {

    
        const access = localStorage.getItem("accessToken");
      
        let url = this.props ? this.props.audioURL : '';
      
        return (
            <div style={{ textAlign: "center" }}>

                {url && url !== '' ? <audio onEnded={(e) => console.info(e)} controls src={url && url !== "" ? "/api/data/getaudio?fugaid=" + url + "&access_token=" + access : ""} autoPlay filename="alfa.mp3"></audio> : null}

                <span className={this.props.audioMeta && this.props.audioMeta.length <= 50 ? "playerMeta" : "playerMetaSmall"} >{this.props.audioMeta}</span>
            </div>
                   
        );
    }
}






export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Player);



// WEBPACK FOOTER //
// ./src/components/player.js